export default __webpack_public_path__ + "static/media/respond-and-get-rewarded-1.01d7c8fb.png";